namespace Gamification.Gamification {
    export interface RisorseChecklistForm {
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IdRisorsa: Serenity.IntegerEditor;
        IdChecklist: Serenity.IntegerEditor;
    }

    export class RisorseChecklistForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.RisorseChecklist';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RisorseChecklistForm.init)  {
                RisorseChecklistForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(RisorseChecklistForm, [
                    'UserId', w0,
                    'TenantId', w0,
                    'IdRisorsa', w0,
                    'IdChecklist', w0
                ]);
            }
        }
    }
}
